import { c as _c } from "react/compiler-runtime";
import { Select } from '@systemeio/components';
import { ChevronDownIcon } from '@systemeio/icons';
import { useFormControlSize } from 'shared/components/form-control-size-context';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface RevenueCurrencyOption<Value extends string> {
  amount: string;
  caption: string;
  value: Value;
}
interface RevenueCurrencySelectProps<Value extends string> {
  onValueChange: (value: Value) => void;
  options: RevenueCurrencyOption<Value>[];
  value: Value;
}

/*
 * The closed field reads as a figure with a caption, so the amount is the brighter part there, while
 * the list keeps the option names primary like any other droplist.
 */
export const RevenueCurrencySelect = t0 => {
  const $ = _c(24);
  const {
    onValueChange,
    options,
    value
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const size = useFormControlSize() ?? "sm";
  let t1;
  if ($[0] !== t) {
    t1 = t("global.currency");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== options) {
    t2 = options.map(_temp);
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onValueChange) {
    t3 = nextValue => {
      if (nextValue !== null) {
        onValueChange(nextValue);
      }
    };
    $[4] = onValueChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== options) {
    t4 = <Select.Value>{selectedValue => {
        const selected = options.find(option_0 => option_0.value === selectedValue);
        return <span className="flex justify-between gap-2"><span className="text-text-secondary truncate">{selected?.caption}</span><span>{selected?.amount}</span></span>;
      }}</Select.Value>;
    $[6] = options;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Select.Icon><ChevronDownIcon /></Select.Icon>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== size || $[10] !== t4) {
    t6 = <Select.Trigger size={size}>{t4}{t5}</Select.Trigger>;
    $[9] = size;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== options) {
    t7 = options.map(_temp2);
    $[12] = options;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <Select.Content><Select.List>{t7}</Select.List></Select.Content>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== size || $[17] !== t1 || $[18] !== t2 || $[19] !== t3 || $[20] !== t6 || $[21] !== t8 || $[22] !== value) {
    t9 = <div className="min-w-48"><Select.Root aria-label={t1} items={t2} size={size} value={value} onValueChange={t3}>{t6}{t8}</Select.Root></div>;
    $[16] = size;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t6;
    $[21] = t8;
    $[22] = value;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  return t9;
};
function _temp(option) {
  return {
    value: option.value,
    label: option.caption
  };
}
function _temp2(option_1) {
  return <Select.Option key={option_1.value} value={option_1.value} textValue={option_1.caption}><span className="flex justify-between gap-4"><span>{option_1.caption}</span><span className="text-text-secondary">{option_1.amount}</span></span></Select.Option>;
}